var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:[
    'srh-Filter_ItemLink',
    { 'srh-Filter_ItemLink-highlight': _vm.highlight } ],attrs:{"role":"button"},on:{"click":function($event){$event.preventDefault();return _vm.changeRoute()}}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }